import React from 'react';
import PropTypes from 'prop-types';
import { StyledRadioButton } from './StyledButtons';

const AppRadioButton = ({
  name,
  checked,
  onChange,
  color,
  highlightColor = 'var(--button-primary-bg)',
  label = null,
  borderColor = 'var(--button-border)',
  customCircleSize = null,
  ...rest
}) => (
  <StyledRadioButton
    name={name}
    checked={checked}
    label={label}
    onChange={onChange}
    color={color}
    highlightColor={highlightColor}
    borderColor={borderColor}
    circleSize={customCircleSize}
    {...rest}
  />
);

AppRadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  color: PropTypes.string,
  highlightColor: PropTypes.string,
  borderColor: PropTypes.string,
  customCircleSize: PropTypes.string,
};

export default AppRadioButton;
